var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPluswhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 11.3C6.6 11.9627 6.10749 12.5 5.5 12.5C4.89251 12.5 4.4 11.9627 4.4 11.3V7.7H1.1C0.492492 7.7 0 7.16272 0 6.5C0 5.83728 0.492492 5.3 1.1 5.3H4.4V1.7C4.4 1.03728 4.89251 0.5 5.5 0.5C6.10749 0.5 6.6 1.03728 6.6 1.7V5.3H9.9C10.5075 5.3 11 5.83728 11 6.5C11 7.16272 10.5075 7.7 9.9 7.7H6.6V11.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPluswhite);
export default __webpack_public_path__ + "static/media/pluswhite.0fb5a7699e9f13ddc3299887400a8b5c.svg";
export { ForwardRef as ReactComponent };